/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Form, Offcanvas } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import classNames from 'classnames';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { UzbekLatin } from 'flatpickr/dist/l10n/uz_latn.js';

import {
  ContactIcon,
  ChevronRightICon,
  CloseIcon
} from 'assets/img/icons/icons';
import SearchContact from './SearchContact';
import './payment.scss';
import { UilCalendarAlt } from '@iconscout/react-unicons';

interface CashSaleContactProps {
  selectedContact?: any;
  setSelectedContact?: any;
  totalAmount?: any;
  setMaturityDate?: any;
  maturityDate?: any;
  noteValue?: string;
  setNoteValue?: any;
}
const CashSaleContact = ({
  selectedContact,
  setSelectedContact,
  totalAmount,
  setMaturityDate,
  maturityDate,
  noteValue,
  setNoteValue
}: CashSaleContactProps) => {
  const { t, i18n } = useTranslation();

  const [checked, setChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleChooseContact = () => {
    setIsOpen(true);
  };

  const getFlatpickrLocale = () => {
    switch (i18n.language) {
      case 'ru':
        return Russian;
      case 'uz':
        return UzbekLatin;
      default:
        return undefined;
    }
  };

  const handleStartDateChange = (date: Date | Date[]) => {
    if (Array.isArray(date)) {
      const startDate = new Date(date[0]);
      startDate.setHours(0, 0, 0, 0); // Set time to 00:00
      const startDateInMillis = startDate.getTime();
      setMaturityDate(startDateInMillis);
    } else {
      const startDate = new Date(date);
      startDate.setHours(0, 0, 0, 0); // Set time to 00:00
      const startDateInMillis = startDate.getTime();
      setMaturityDate(startDateInMillis);
    }
  };

  return (
    <div className="cash-contact-container">
      {!selectedContact?.id ? (
        <div className="cash-contact" onClick={handleChooseContact}>
          <ContactIcon />
          <div className="cash-contact-info">
            <p className="cash-contact-title">{t('contact')}</p>
            <p className="cash-contact-placeholder">{t('Выберите')}</p>
          </div>
          <ChevronRightICon />
        </div>
      ) : (
        <div className="cash-contact">
          <ContactIcon />

          <div className="contact-lst">
            <p className="contact-name">
              {selectedContact?.first_name || ''}{' '}
              {selectedContact?.last_name || ''}
            </p>
            <p className="contact-phone">{selectedContact?.phone_number}</p>
          </div>
          <span
            className="cash-contact-close"
            onClick={() => {
              setSelectedContact({});
              setChecked(false);
            }}
          >
            <CloseIcon />
          </span>
        </div>
      )}

      <div className="cash-sale-credit">
        <p className="cash-sale-credit-text">{t('sale_on_credit')}</p>
        <Form.Check
          disabled={selectedContact?.id ? false : true}
          type="switch"
          className="cursor-pointer"
          checked={checked}
          onChange={e => {
            setChecked(e.target.checked);
          }}
        />
      </div>

      {checked && (
        <div className="cash-sale-credit-info">
          <div className="credit-info-details">
            <span>{t('current_debt')}</span>
            <span>
              {totalAmount
                ? new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 4,
                    useGrouping: true
                  })
                    .format(totalAmount)
                    .replace(/,/g, ' ')
                : 0}
            </span>
          </div>

          <div className="credit-info-date-info">
            <Form.Group className="flatpickr-input-container mb-3">
              <Form.Floating>
                <Flatpickr
                  className={classNames('form-control')}
                  options={{
                    nextArrow: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/></svg>`,
                    prevArrow: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg>`,
                    locale: getFlatpickrLocale(),
                    monthSelectorType: 'static',
                    onDayCreate: (...[, , , dayElem]) => {
                      if (
                        dayElem.dateObj.getDay() === 5 ||
                        dayElem.dateObj.getDay() === 6
                      ) {
                        dayElem.className += ' weekend-days';
                      }
                    },

                    dateFormat: 'M j, Y',
                    disableMobile: true
                  }}
                  value={maturityDate}
                  onChange={handleStartDateChange}
                  placeholder={t('maturity_date')}
                />
                <label htmlFor="startDatepicker" className="ps-6">
                  {t('maturity_date')}
                </label>
                <UilCalendarAlt className="flatpickr-icon text-700" size={16} />
              </Form.Floating>
            </Form.Group>

            <Form.Floating>
              <Form.Control
                type="text"
                placeholder={t('note')}
                onFocus={e => e.target.select()}
                autoComplete="off"
                value={noteValue}
                onChange={e => setNoteValue(e.target.value)}
              />
              <label htmlFor="floatingInputCustom">{t('note')}</label>
            </Form.Floating>
          </div>
        </div>
      )}

      <Offcanvas
        show={isOpen}
        onHide={() => {
          setIsOpen(false);
        }}
        placement="end"
        backdrop="static"
        keyboard={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ fontSize: '24px', fontWeight: '600' }}>
            {t('contact')}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SearchContact
            setSelectedContact={setSelectedContact}
            setIsOpen={setIsOpen}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default CashSaleContact;
